/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
// import { Chart as ChartJS, registerables } from 'chart.js';
// import { Chart } from 'react-chartjs-2'
// ChartJS.register(...registerables);
// import 'chartjs-adapter-moment';

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import Grid from "@mui/material/Grid";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftSelect from "components/SoftComponents/SoftSelect";

import DashboardLayout from "template/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "template/examples/Navbars/DashboardNavbar";
import Footer from "template/examples/Footer";

// Soft UI Dashboard PRO React helper functions
import gradientChartLine from "assets/theme/functions/gradientChartLine";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//Backend access
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Switch, Tooltip } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


function EventSelects({ startTime, setStartTime, endTime, setEndTime, advancedToggle, setAdvancedToggle }) {

  const header = (
    <SoftBox m={1}>
      <Grid container spacing={{ xxs: 1, md: 3 }}>
        <Grid item xxs={12} md={6}>
          <SoftBox display="flex" flexDirection="row" justifyContent={{ xxs: "center", md: "flex-end" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker format="DD/MM/YYYY" value={startTime} onChange={(new_value) => { setStartTime(new_value) }} />
            </LocalizationProvider>
          </SoftBox>
        </Grid>
        <Grid item xxs={12} md={4}>
          <SoftBox display="flex" flexDirection="row" justifyContent={{ xxs: "center", md: "flex-start" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker format="DD/MM/YYYY" value={endTime} onChange={(new_value) => { setEndTime(new_value) }} />
            </LocalizationProvider>
          </SoftBox>
        </Grid>
        <Grid item xxs={12} md={2}>
          <SoftBox pt={1} pl={2} display="flex" flexDirection="row" justifyContent="center" alignItems="center">
            <Switch value={advancedToggle} onChange={(new_value) => { setAdvancedToggle(!advancedToggle) }} />
            <SoftBox pt={0.5}>
              <Tooltip title="Toggle Advanced Chart" placement="right">
                <HelpOutlineIcon fontSize="small" sx={{ paddingLeft: '0.5rem' }} />
              </Tooltip>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox >
  );

  return header;

}

// Typechecking props for the EventSelects
EventSelects.propTypes = {
  startTime: PropTypes.instanceOf(moment()),
  setStartTime: PropTypes.func,
  endTime: PropTypes.instanceOf(moment()),
  setEndTime: PropTypes.func,
  advancedToggle: PropTypes.bool,
  setAdvancedToggle: PropTypes.func
};

export default EventSelects;

